import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-commission-plan-rule-sales-team-edit',
    templateUrl: './commission-plan-rule-sales-person-edit.component.html',
    styleUrls: ['./commission-plan-rule-sales-person-edit.component.scss'],
    standalone: false
})
export class CommissionPlanRuleSalesPersonEditComponent implements OnInit {
  commissionPlanRuleId: string;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.commissionPlanRuleId = this.route.snapshot.params['id'];
  }
}
